import { useRef, useEffect, useState } from "react";

export default function SignaturePad({ label, value, onChange, testid }) {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#000";

    // Si ya hay un valor, pero no lo podemos dibujar facil aqui sin mas logica,
    // simplemente mostramos el placeholder o el canvas vacio.
    // En una app real, podrias cargar la imagen base64 en el canvas.
  }, []);

  const startDrawing = (e) => {
    setIsDrawing(true);
    draw(e);
  };

  const stopDrawing = () => {
    setIsDrawing(false);
    const canvas = canvasRef.current;
    const dataUrl = canvas.toDataURL("image/png");
    onChange(dataUrl);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const rect = canvas.getBoundingClientRect();

    let x, y;
    if (e.touches) {
      x = e.touches[0].clientX - rect.left;
      y = e.touches[0].clientY - rect.top;
    } else {
      x = e.clientX - rect.left;
      y = e.clientY - rect.top;
    }

    ctx.lineTo(x, y);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.beginPath();
    onChange("");
  };

  return (
    <div className="space-y-2">
      {label && <label className="text-xs font-bold text-navy uppercase tracking-widest">{label}</label>}
      <div className="relative border-2 border-dashed border-border bg-white rounded-lg overflow-hidden group">
        <canvas
          ref={canvasRef}
          width={400}
          height={200}
          onMouseDown={startDrawing}
          onMouseUp={stopDrawing}
          onMouseMove={draw}
          onTouchStart={startDrawing}
          onTouchEnd={stopDrawing}
          onTouchMove={draw}
          className="w-full h-40 cursor-crosshair touch-none"
          data-testid={testid}
        />
        {value ? (
          <div className="absolute inset-0 bg-white pointer-events-none flex items-center justify-center">
            <img src={value} alt="Firma" className="max-h-full" />
          </div>
        ) : (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-20 text-[10px] font-black uppercase">
            Firmar aquí
          </div>
        )}
        <button
          type="button"
          onClick={clear}
          className="absolute top-2 right-2 p-1.5 bg-critical/10 text-critical text-[10px] font-bold uppercase rounded hover:bg-critical hover:text-white transition-colors"
        >
          Limpiar
        </button>
      </div>
    </div>
  );
}
